import * as Icons from "lucide-react";

export default function DynIcon({ name, className }) {
  if (name === "Drone") return <svg data-testid="drone-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="5" cy="5" r="3" /><circle cx="19" cy="5" r="3" />
    <circle cx="5" cy="19" r="3" /><circle cx="19" cy="19" r="3" />
    <path d="m7 7 3 3m4 0 3-3M7 17l3-3m4 0 3 3" />
    <rect x="9" y="9" width="6" height="6" rx="2" /><circle cx="12" cy="12" r="1" />
  </svg>;
  const Cmp = Icons[name] || Icons.Building2;
  return <Cmp className={className} />;
}
